// auth.js — Centralized auth token storage accessors.
// All reads and writes to auth-related storage keys go through this module,
// making it easy to switch storage backends (e.g. sessionStorage ↔ localStorage)
// or key names in one place.

const storage = localStorage;

export const getAuthToken = () => storage.getItem('access_token');
export const getRefreshToken = () => storage.getItem('refresh_token');
export const getTokenExpiry = () => storage.getItem('token_expiry');
export const getLoggedInUser = () => storage.getItem('logged_in_user');
// Display name (e.g. given_name) shown in the UI. Distinct from logged_in_user,
// which holds the email and is used as the tutor/user identifier.
export const getLoggedInUserName = () => storage.getItem('logged_in_user_name');

export const setAuthToken = (token) => storage.setItem('access_token', token);
export const setRefreshToken = (token) => storage.setItem('refresh_token', token);
export const setTokenExpiry = (expiry) => storage.setItem('token_expiry', expiry);
export const setLoggedInUser = (user) => storage.setItem('logged_in_user', user);
export const setLoggedInUserName = (name) => storage.setItem('logged_in_user_name', name);

// clearAuthStorage()
//    Explicitly clear all auth-related storage on logout to prevent stale data issues
//    Does not clear tt_welcome_dismissed to preserve welcome message state across sessions
export const clearAuthStorage = () => {
  storage.removeItem('access_token');
  storage.removeItem('refresh_token');
  storage.removeItem('token_expiry');
  storage.removeItem('logged_in_user');
  storage.removeItem('logged_in_user_name');
  try {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('token_expiry');
    sessionStorage.removeItem('logged_in_user');
    sessionStorage.removeItem('logged_in_user_name');
  } catch {
    // Ignore storage access errors in restricted contexts.
  }
};
